import React, { useState } from "react";
import placeloc from "../../../assets/img/icons/placelocation.svg";
import {
  Circle,
  FeatureGroup,
  LayerGroup,
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  useMap,
  useMapEvent,
  ZoomControl
} from "react-leaflet";
import marker from "../../../assets/img/icons/loc.svg";
import L from "leaflet";

const PlaceLocation = ({ inforesidencedetail ,admin=false}) => {
  const greenIcon = L.icon({
    iconUrl: marker,
    iconSize: [52, 67],
    iconAnchor: [40, 41]
  });
  const [center, setcenter] = useState([
    inforesidencedetail.lat,
    inforesidencedetail.lng
  ]);
  const greenOptions = { color: "green" };
  const purpleOptions = {
    color: "#00A6A6",
    fillColor: "rgba(0, 166, 166, 0.6)"
  };
console.log(inforesidencedetail.has_map_accuracy)
  return (
    <div className="PlaceLocation">
      <div className="PlaceReserve">
        <img src={placeloc} />
        <div>
          <p className="text-[#12171C] text-[20px] font-[700] ">محدوده مکانی</p>
          <p className="text-[#51555A] text-[18px] font-[600] mt-[4px]">
            وقعیت مکانی دقیق اقامتگاه پس از رزرو کامل ارسال خواهد شد.
          </p>
        </div>
      </div>
      <div className="Map">
        <MapContainer maxZoom={15} center={center} zoom={15}>
          <TileLayer
            attribution="&copy; <a href=&quot;http://www.openstreetmap.org/copyright&quot;>OpenStreetMap</a> &copy; <a href=&quot;http://cartodb.com/attributions&quot;>CartoDB</a>"
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <FeatureGroup pathOptions={purpleOptions}>
            <Popup>Popup in FeatureGroup</Popup>
            <Circle
              center={ admin || inforesidencedetail.has_map_accuracy ?[
                inforesidencedetail.lat,
                inforesidencedetail.lng
              ] :[
                inforesidencedetail.lat + 0.0008,
                inforesidencedetail.lng + 0.0008
              ]}
              radius={200}
            />
          </FeatureGroup>
         

          {/* <Geocoder address="اصفهان" /> */}
          {/* <MapSearch provider={new OpenStreetMapProvider()} /> */}
        </MapContainer>
      </div>
    </div>
  );
};

export default PlaceLocation;
